module.exports = __webpack_public_path__ + "static/media/connected-bell-ENGIE.1e74e24a.png";